import { getAuthorizationHeader, getHeadersWithUniqueVisitorId, ProductRewardSearchResult } from "@brandclub/common-ui";
import { HOST_DOMAIN } from "../../utils/domain";
import { DtcSiteProduct, DtcSiteProductResponse } from "../types";

const DOMAIN = HOST_DOMAIN + "/api-rewards";

export const autoUpdateDTCProducts = async (
  dtcProducts: {
    stacklineSku: string;
    dtcProductPageUrl: string;
    dtcSku: string | undefined;
  }[],
  signal?: AbortSignal
) => {
  const headers = await getHeadersWithUniqueVisitorId();
  const res = await fetch(DOMAIN + `/product/autoUpdateDTCProducts`, {
    method: "POST",
    headers,
    signal,

    body: JSON.stringify({ dtcProducts }),
  });
  if (res.ok) {
    return await res.json();
  } else {
    throw new Error("Error auto updating DTC products");
  }
};

export async function setToRecentlyViewedProduct(
  sku: string,
  eventName: string,
  paramsToTrack: Record<string, any>
) {
  const data = { ...paramsToTrack, eventName };
  const url = DOMAIN + `/recentlyViewed/setProduct?sku=${sku}`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      ...(await getAuthorizationHeader()),
    },
    body: JSON.stringify(data),
  });
  if (res.ok) {
    return await res.json();
  } else {
    throw new Error("Error setting recently viewed product");
  }
}

export const getBrandclubProduct = async (
  stacklineSku: string,
  signal?: AbortSignal
): Promise<ProductRewardSearchResult> => {
  const res = await fetch(DOMAIN + `/product/${stacklineSku}`, {
    headers: await getAuthorizationHeader(),
    signal,
  });
  if (res.ok) {
    return res.json();
  } else {
    throw new Error("Error fetching brandclub product");
  }
};

const validateDTCSiteProductResponse = (
  data: unknown
): DtcSiteProductResponse => {
  if (typeof data !== "object") {
    throw new Error(
      `Received unexpected dtc product data type: ${typeof data}`
    );
  }

  if (data && "product" in data) {
    return data as DtcSiteProductResponse;
  }

  // no product found
  throw new Error("No product found");
};

/**
 * Fetches the Shopify product data for the given product URL
 * @param dtcSiteProductUrl The URL of the product
 * @param signal The signal to abort the request
 * @returns The shopify product data
 */
export const fetchDtcSiteProduct = async (
  dtcSiteProductUrl: string,
  signal?: AbortSignal
): Promise<DtcSiteProduct> => {
  let url = dtcSiteProductUrl;
  if (url && url.endsWith("/")) {
    url = url.slice(0, -1);
  }
  const response = await fetch(url + "/product.json", {
    method: "GET",
    signal,
  });
  if (!response.ok) {
    throw new Error("Failed to fetch site product");
  }
  const data = await response.json();
  return validateDTCSiteProductResponse(data).product;
};
